const httpRegex = /^(https?:\/\/)?((www|\w\w)\.)?/;

export const removeHttpFromUrl = (url: string | undefined | null) => {
  if (!url) {
    return '';
  }
  return url.replace(httpRegex, '');
};
